import React from "react"
import Filters from "./filters"
 import Stats from "./stats"
import ResultsList from "./results"
 import Sort from "./sort"

/**
 * General search component
 */
const GeneralSearch = () => (
    <div className="search">
        <Filters withQuery withClear />
        <div className="search__main">
            <div className="search__header">
                <h1>Search Results</h1>
                <div className="flex-group soft--top">
                  <Stats />
                    <Sort /> 
                </div>
            </div>
            <ResultsList />
        </div>
    </div>
)
export default GeneralSearch